// @flow

import React from 'react';

import type {EventButtonType} from 'src/types';
import styled from 'styled-components';

export const SubmenuButton = ({
  title,
  icon,
  active,
  onClick,
  ...other
}: EventButtonType) => (
  <div className="btn-container">
    <div className="editor-tooltip">{title}</div>
    <button
      {...other}
      className={active ? 'btn color-button-active' : 'btn color-button'}
      onClick={onClick}
    >
      <i className={`${icon}`} />
    </button>
  </div>
);

export const StyledSeparator = styled.div`
  width: 15px;
`;
